import { MembershipStep } from "components/Membership/membershipTypes";
import StepRelationship from "components/Step/StepRelationship";
import { Subscription } from "lib/api/subscription";

export const MEMBERSHIP_STEP_RELATIONSHIP: MembershipStep = {
  component: (state) => {
    const backButtonProps = {
      onClick: () => state.routePrevStep?.(),
    };

    return (
      <StepRelationship
        {...state}
        initialValues={state.relationshipValues}
        stepFooterProps={{ backButtonProps }}
        stepHeaderProps={{ backButtonProps }}
        subscription={state.subscription as Subscription}
      />
    );
  },
  id: "membership-id-relationship",
  slug: "relationship",
};

export const MEMBERSHIP_STEP_RELATIONSHIP_SUPPRESS_BACK_NAVIGATION: MembershipStep =
  {
    ...MEMBERSHIP_STEP_RELATIONSHIP,
    component: (state) => (
      <StepRelationship
        {...state}
        initialValues={state.relationshipValues}
        // step is submitted before dummy account creation,
        // which is necessary for GSU submission
        suppressGuidedSignUpSubmission
        stepFooterProps={{
          suppressBackButton: true,
        }}
        stepHeaderProps={{
          suppressBackButton: true,
        }}
        subscription={state.subscription as Subscription}
      />
    ),
  };

export default MEMBERSHIP_STEP_RELATIONSHIP;
